import { ProductTemplateConfigType } from '#src/utils';

const config: ProductTemplateConfigType = {
  dynamicComponents: {
    PROMO_CODE_WIDGET: {
      template: 'standard',
      params: {
        promoCode: {
          isVisible: true,
        },
      },
    },
  },
};

export default config;
